import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { forgotPasswordCheckEmailSuperAdmin } from '../../service/endpoints';
import '../../Auth.css';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = (email || '').trim();
    if (!trimmed) {
      toast.error('Email is required.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      toast.error('Please enter a valid email.');
      return;
    }
    setLoading(true);
    try {
      const res = await forgotPasswordCheckEmailSuperAdmin({ email: trimmed });
      if (res?.success) {
        toast.success(res?.message ?? res?.data?.message ?? 'OTP sent to your email.');
        navigate('/forgot-password/otp', { state: { email: trimmed } });
      } else {
        toast.error(res?.message ?? res?.error?.message ?? res?.data?.error_msg ?? 'Something went wrong.');
        setLoading(false);
      }
    } catch (err) {
      const msg = err?.error_msg ?? err?.message ?? 'Unable to send OTP. Please try again.';
      toast.error(msg);
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid auth-page h-100 d-flex align-items-center justify-content-center">
      <div className="Login-card auth-card">
        <div className="card-body">
          <h3 className="card-title mb-0"><span className="span"></span>Forgot Password</h3>
          <p className="auth-subtitle">Enter your email to receive an OTP</p>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="mb-3">
              <label className="form-label auth-label">Email</label>
              <input
                type="email"
                className="form-control auth-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                autoComplete="email"
              />
            </div>
            <button type="submit" className="button auth-btn py-2 w-100" disabled={loading}>
              {loading ? 'Sending…' : 'Send OTP'}
            </button>
          </form>

          <p className="text-center small mt-3 mb-0 auth-footer-link">
            <button type="button" onClick={() => navigate('/login')} className="text-secondary btn btn-link p-0">← Back to Login</button>
          </p>
        </div>
      </div>
      <ToastContainer limit={2} position="top-center" />
    </div>
  );
};

export default ForgotPassword;
